module.exports = __webpack_public_path__ + "static/img/banner_mobile7.65299d87.jpg";